<template>
  <div class="rich-text-chart">
    <x-loading :visible="loading">
      <!-- <cube-scroll> -->
      <!-- eslint-disable-next-line -->
        <div v-html="richText" class="read-richtext w-e-text"></div>
      <!-- </cube-scroll> -->
    </x-loading>
  </div>
</template>

<script>
import apis from '@/api'

export default {
  props: {
    chartConfig: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      richText: '',
      loading: false,
      queryParams: {}
    }
  },
  created() {
    this.queryParams = this.$route.query
    this.queryData()
  },
  methods: {
    refresh() {
      this.queryData()
    },
    queryData() {
      const request = {
        ...apis.FORM.QUERY_RICH_CONTENT,
        params: {
          reportFormId: this.queryParams.formId,
          chartUuid: this.chartConfig.uuid
        }
      }
      this.loading = true
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.loading = false
            this.richText = resp.data.richTextContext
          },
          (err) => {
            this.loading = false
          }
        )
        .asyncErrorCatch(
          (err) => {
            this.loading = false
          }
        )
    }
  }
}
</script>

<style lang="scss">
.rich-text-chart {
  .x-loading > img {
    height: 14.7rem;
  }
  .x-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    .read-richtext {
      height: calc(100% - 1.428571rem);
      font-size: 0.857143rem;
      overflow-y: auto;
      text-align: left;
      word-break: break-word;
      overflow: hidden;
      p {
        margin: 0;
      }
      pre {
        display: block;
        margin: 0 0 .7143rem;
        font-size: .857rem;
        color: #333;
        word-break: break-all;
        word-wrap: break-word;
        background-color: #f5f5f5;
        border: 1px solid #ccc;
        border-radius: 4px;
        overflow: hidden;
        code {
          white-space: pre-wrap;
          word-break: break-word;
        }
      }
      blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
      }
    }
  }
}
</style>
